import {
    AGGREGATION_LOADING,
    AGGREGATION_ERROR,
    AGGREGATION_GET_USER
} from "actions/aggregation/constants";

const initialState = {
    loading: false,
    errors: [],

    aggregatedUser: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case AGGREGATION_LOADING:
            return {
                ...state,
                loading: action.payload.content
            };
        case AGGREGATION_ERROR:
            return {
                ...state,
                errors: action.payload.content
            };
        case AGGREGATION_GET_USER:
            return {
                ...state,
                aggregatedUser: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/aggregationReducer.js